import { createSlice } from '@reduxjs/toolkit';
import { productGetLandingPage } from './productAsyncThunk';

const productGetLandingPageSlice = createSlice({
  name: "product",
  initialState: {
    payload: [],
    isLoading: false,
    isSuccess: false,
    isFail: false,
  },
  reducers: {},
  extraReducers: {
    [productGetLandingPage.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isFail = false;
    },
    [productGetLandingPage.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.payload = [...action.payload.list];
    },
    [productGetLandingPage.rejected]: (state, action) => {
      state.isLoading = false;
      state.isFail = true;
    },
  },
});

export default productGetLandingPageSlice.reducer;